module.exports = __webpack_public_path__ + "assets/img/logo-dark.682e2a50.png";